<template>
  <div class="container" >

    <div class="form">
      <el-form ref="formRef" :inline="true" label-width="90px" :model="form">
        <el-row>
          <el-col :span="5">
            <el-form-item label="指南名称" prop="guideName">
              <el-input v-model="form.guideName" clearable placeholder="请输入指南名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="19">
            <div class="buttons" >
              <el-button type="primary" @click="query_handler" >查询</el-button>
              <el-button @click="reset_handler" >重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="list">
      <div class="add" >
        <el-button @click="add_handler" class="add-button-class" type="primary" size="small" >录入指南</el-button>
      </div>
      <el-table
          :data="table"
          style="width: 100%">
        <el-table-column
            prop="serialNumber"
            align="center"
            label="序号">
        </el-table-column>
        <el-table-column
            prop="guideName"
            align="center"
            label="指南名称">
        </el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="上传时间">
        </el-table-column>
        <el-table-column
            fixed="right"
            align="center"
            label="操作">
          <template #default="{ row }" >
            <div class="links" >
              <el-link type="primary" @click="edit_handler(row)" :disabled="row.auditStatus === '1'">编辑</el-link>
              <span v-if="row.auditStatus === '1'" class="reference-class">
                  <el-link type="danger" :disabled="row.auditStatus === '1'">删除</el-link>
              </span>
              <el-popconfirm
                  v-else
                  confirm-button-text="确定"
                  cancel-button-text="取消"
                  icon="el-icon-info"
                  title="确定要删除该指南吗？"
                  @confirm="confirmEvent(row)"
                  @cancel="cancelEvent">
                <template #reference>
                  <span class="reference-class">
                    <el-link type="danger">删除</el-link>
                  </span>
                </template>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="form.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
    <AuthoritativeGuideAddDialog
        v-model="add_data.show"
        :id="add_data.id"
        :guideName="add_data.guideName"
        :guideContent="add_data.guideContent"
        @updateList="getList">
        <template v-slot:default="slotProps">
          <el-button :disabled="slotProps.isUpdate" type="primary" @click="slotProps.confirm_handler">提交审核</el-button>
          <el-button @click="slotProps.handleClose">取 消</el-button>
        </template>
    </AuthoritativeGuideAddDialog>
  </div>
</template>

<script>
import AuthoritativeGuideAddDialog from "./components/AuthoritativeGuideAddDialog";
import { submitHint } from '../common'
export default {
  name: "AuthoritativeGuide",
  components: {
    AuthoritativeGuideAddDialog
  },
  data() {
    return {
      form: {
        pageNum: 1,
        pageSize: 10,
        guideName: "",
      },
      table: [],
      total: 0,
      add_data: {
        show: false,
        id: "",
        guideName: "",
        guideContent: "",
      }
    }
  },
  created() {
    this.getList();
  },
  mounted() {

  },
  methods: {
    async getList() {
      try {
        const res = await this.$post("guide/list", this.form);
        if (!res) return false;
        const { data } = res;
        this.total = data.total;
        this.table = data.list;
      }catch (e) {
        console.error(`获取权威指南接口失败`, e);
      }
    },
    query_handler() {
      this.form.pageNum = 1;
      this.getList();
    },
    reset_handler() {
      this.$refs.formRef.resetFields();
      this.getList();
    },
    // 添加
    add_handler() {
      this.add_data.id = "";
      this.add_data.show= true;
    },
    // 编辑
    edit_handler(row) {
      this.add_data.id = row.id;
      this.add_data.guideName = row.guideName;
      this.add_data.guideContent = row.guideContent;
      this.add_data.show= true;
    },
    // 确定删除
    async confirmEvent(row) {
      try {
        const res = await this.$post("guide/delete", {
          id: row.id,
          userId: this.$store.state.user_info.userId
        });
        if (!res) return false;
        submitHint.call(this);
        await this.getList();
      }catch (e) {
        console.error(`删除权威指南接口失败`, e);
      }
    },
    // 取消删除
    cancelEvent() {

    },
    handleSizeChange(e) {
      this.form.pageSize= e;
      this.getList(this.form);
    },
    handleCurrentChange(e) {
      this.form.pageNum= e;
      this.getList(this.form);
    },
  }
}
</script>

<style scoped lang="scss">
.container{
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  .list{
    flex: 1;
    .add-button-class{
      width: 100px;
    }
  }
}
.buttons{
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>
